export default __webpack_public_path__ + "static/MediaContentThreeFancybox-76e09c2ee1662a37b0680778e1b1a1c4.webp";